<template>
  <v-card
    class="
      terms-top-panel
      card-section
      relative
      py-6
      py-lg-4
      d-flex
      flex-column
      flex-md-row
    "
  >
    <v-btn
      class="text-primary text-decoration-underline font-weight-bold"
      text
      absolute
      top
      right
      @click="$emit('print')"
    >
      {{ $t('buttons.print') }}
    </v-btn>

    <div class="terms-top-panel__icon d-flex justify-center pb-7 pb-md-0">
      <img
        class="terms-top-panel__img"
        src="@img/mascot-terms.svg"
        alt="terms illustration"
      />
    </div>

    <div
      class="
        terms-top-panel__content
        d-flex
        flex-column
        align-center
        align-md-start
        px-4
        pr-md-0
        pl-md-5
      "
    >
      <v-card-title class="terms-top-panel__title">
        {{ $t('terms.title') }}
      </v-card-title>
      <h3
        v-html="$t('terms.subtitle')"
        class="
          terms-top-panel__subtitle
          fs-16
          fs-md-18
          mt-4
          mt-md-2
          font-weight-semibold
          font-weight-lg-bold
        "
      />
    </div>
  </v-card>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class TermsTopPanel extends Vue {}
</script>

<style lang="scss" scoped>
@import '@/styles/include-media.scss';

.terms-top-panel {
  &__content {
    flex: 1 1;
  }

  &__title {
    font-size: 32px !important;

    @include media('<desktop') {
      font-size: 28px !important;
    }

    @include media('<tablet') {
      font-size: 20px !important;
    }
  }

  &__subtitle {
    max-width: 600px;

    @include media('<tablet') {
      text-align: center;
    }
  }

  &__img {
    width: 130px;

    @include media('<tablet') {
      width: 150px;
    }
  }
}
</style>
